import { render, staticRenderFns } from "./StudentVerification.vue?vue&type=template&id=826dea5a&scoped=true"
import script from "./StudentVerification.vue?vue&type=script&lang=js"
export * from "./StudentVerification.vue?vue&type=script&lang=js"
import style0 from "./StudentVerification.vue?vue&type=style&index=0&id=826dea5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826dea5a",
  null
  
)

export default component.exports